import { Button, dataLoader } from "@unbxd-ui/unbxd-react-components";
import { Fragment, useEffect, useRef, useState } from "react";
import VisualSearchCamera from "./VisualSearchCamera";
import "../../../src/style/visualsearchdemo.scss";
import Xarrow, { useXarrow, Xwrapper } from "react-xarrows";
import "../../../src/style/visualSearchLanding.scss";
import ExtractProductAttributes from "./ExtractProductAttributes";
import EnhancedSearchAccuracy from "./EnhancedSearchAccuracy";
import AiStylist from "./AiStylist";
import cloneDeep from "lodash.clonedeep";
import Footer from "../common/Footer";
import Header from "../common/Header";
import downArrow from "../../common/images/down_arrow.png";
import searchIcon from "../../common/images/search_icon.png";

function VisualSearchLanding(props) {
    const [startCamera, setStartCamera] = useState(false);
    const [hotSpotData, setHotspotData] = useState({});
    const [products, setProducts] = useState([]);
    const [pngImageSrc, setPngImageSrc] = useState("");
    const [showLandingPage, setShowLandingPage] = useState(true);
    const [showSearchPage, setShowSearchPage] = useState(false);
    const [showCanvas, setShowCanvas] = useState(false);
    const [isImageCaptured, setIsImageCaptured] = useState(false);
    const [showLoader, setShowLoader] = useState(false);
    const [canvasSrc, setCanvasSrc] = useState("");
    const [hotSpotIndex, setHotspotIndex] = useState(-1);
    const [vertical, setVertical] = useState("apparel");
    const [verticalClass, setVerticalClass] = useState("close");

    const [imageURL, setImageURL] = useState('');

    const [sampleImages, setSampleImages] = useState({
        apparel: [
            "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSXdnAmG0qvStpv9BA6OrT0r22kp_4V26CNOptaiil5VQ&s=10",
            "https://m.media-amazon.com/images/I/51+DZ+7jbjL._AC_SX679_.jpg",
            "https://i.pinimg.com/736x/d2/c5/75/d2c57597619637a7ddda0e5e1eb70829.jpg",
        ],
        home: [
        'https://img.zcdn.com.au/lf/50/hash/38868/20181434/4/.jpg',
        'https://img.zcdn.com.au/lf/79/hash/38080/20246301/4/200cm%2BEden%2BSolid%2BAmerican%2BOak%2BTV%2BUnit.jpg',
        'https://img.zcdn.com.au/lf/79/hash/37973/19082140/4/White%2BTribeca%2B6%2BDrawer%2BLowboy%2BDresser.jpg',
        'https://img.zcdn.com.au/lf/79/hash/38295/20394668/4/2%2BPiece%2BAlessa%2BRocking%2BChair%2B%2526%2BFootstool%2BSet.jpg',
        'https://content.valuecityfurniture.com/images/product/hanover-youth-bedroom_light-brown_6-pc-twin-bedroom_3064107_2043517.jpg',
        ],
        footwear: [
            'https://encrypted-tbn1.gstatic.com/images?q=tbn:ANd9GcTNrcuW55mIeRA4ErALcP6XwsYOalQCbAXpTcBP1Kjcr5n5RaZL',
            'https://cloud.camper.com/is/image/JGVzaG9wMDNtYmlnZ3JleSQ=/K400631-001_LF.jpg',
            'https://www.gravitypope.com/cdn/shop/files/K201253-018_L.jpg?v=1700017140&width=2240',
            'https://m.media-amazon.com/images/I/51Atwl68U+L._AC_SY695_.jpg',
            'https://www.instyle.com.tr/wp-content/uploads/2024/03/camper-yeni-unisex-modeli-rokuyu-tanitiyor-1.png',
            'https://cloud.camper.com/is/image/JGVzaG9wMDNtYmlnZ3JleSQ=/27205-277_LF.jpg',
            'https://img01.ztat.net/article/spp-media-p1/607f19683fc44003bfe19a325a6e1192/e59c83d813134af18f1e5ba24c0dfbe7.jpg?imwidth=762',
            'https://i.ebayimg.com/images/g/JOUAAOSwMldkMN2t/s-l1600.jpg',
            'https://www.bugatti-fashion.com/media/bugatti_magazin-brauneschuhe01.jpg',
            'https://m.media-amazon.com/images/I/71w+e2HOiKL._AC_UF1000,1000_QL80_.jpg',
            'https://stylelabstore.co.za/cdn/shop/collections/SOCIAL_FB_CR2_28.jpg?v=1638347140',
            'https://perkclothing.com/cdn/shop/articles/Frame_131.jpg?v=1672866418',
            'https://img01.ztat.net/article/spp-media-p1/960ed84bc04d3449bf9a581393745e2b/97176a3d9f9c4720a019eb161d63a10c.jpg?imwidth=1800'
        ]
    });
    const [selectedSampleImage, setSelectedSampleImage] = useState(sampleImages.apparel[0]);

    const toggleVerticalDD = () => {
        setVerticalClass(verticalClass === "close" ? "open" : "close");
    };

    const onVerticalChange = (event) => {
        setVertical(event.target.getAttribute('data-vertical'));
        toggleVerticalDD();
        setSelectedSampleImage(sampleImages[event.target.getAttribute('data-vertical')][0]);
    };

    const handleImageURLChange = (e) => {
        setImageURL(e.target.value);
    };

    const handleSubmitImageURL = () => {
        if (imageURL.trim() !== '') {
            setSelectedSampleImage(imageURL.trim());

        }
    };

    const onSubmitImageURL = (action, url) => {
        setShowLandingPage(false);
        setSelectedSampleImage(url.trim());
        onSubmitPhoto(action, url.trim());
    }

    const [showImageResults, setShowImageResults] = useState(false);
    const [showImageZeroResults, setShowImageZeroResults] = useState(false);
    const [imageLoaded, setImageLoaded] = useState(false);
    const [tags, setTags] = useState([]);
    const [allCurrentTags, setAllCurrentTags] = useState([]);
    const [tagsLoading, setTagsLoading] = useState(false);
    var canvas = useRef(null);

    const [imageSearchSource, setImageSearchSource] = useState("");
    const [showImageSrc, setShowImageSrc] = useState(false);
    const base64Payload = useRef("");

    const addImageViewerAndBoundingBoxes = (action, url) => {
        if (action === "urlSearch") {
            setPngImageSrc(url);
        } else if (action === "hotSpotClick") {
            /** No change in image src */
        } else {
            var pngImage = canvas.current.toDataURL('image/png');
            setPngImageSrc(pngImage);
        }
        setShowImageSrc(true);
    }

    const onHotSpotClick = (url, index, evt) => {
        // evt.stopImmediatePropagation();
        evt.stopPropagation();
        onSubmitPhoto("hotSpotClick", url);
        setHotspotIndex(index);
    }

    const onImageLoad = (e) => {
        document.documentElement.style.setProperty("--vs-tags-cont-height",`${e.target.clientHeight}px`);
        setImageLoaded(true);
    }

    let imageClone = useRef(null);
    let imageBoxesRef = useRef(null);
    let searchResponseRef = useRef(null);

    const onSubmitPhoto = (action, url) => {

        setShowImageResults(false);
        setShowImageZeroResults(false);
        setImageLoaded(false);
        setShowImageSrc(false);
        setStartCamera(false);
        setShowSearchPage(false);
        setShowCanvas(false);
        setShowLoader(true);
        setShowImageSrc(true);


        if (action !== "hotSpotClick") {
            setImageSearchSource(action);
            imageBoxesRef.current = null;
            imageClone.current = null;
            searchResponseRef.current = null;
            setHotspotData({});
        }

        let apiKey;
        let siteKey;
        switch (vertical) {
            case "footwear":
                apiKey = "13b9b8c991cb196499de5b04eb0dfd65";
                siteKey = "ss-unbxd-camper-prod38961673358280";
                break;
            case "home":
                apiKey = "b88a1eb250f06f342af315e427e4ae17";
                siteKey = "ss-unbxd-Fantastic-Furniture-Prod46751695093421";
                break;
            default:
                apiKey = "1ccbb7fcb0faf770d1c228be80ba16d9";
                siteKey = "ss-unbxd-aus-demo-fashion831421736321881";
        }

        setTags([]);
        /** Fire search images api */
        const apiUrl = (action === "hotSpotClick") ? `https://search.unbxd.io${url}?rows=20&start=0&fields=imageUrl,title,name&promotion=false` : `https://search.unbxd.io/v2.0/sites/${siteKey}/images?rows=20&start=0&fields=imageUrl,title,name&promotion=false`

        const getHeaders = () => {

            if (action === "hotSpotClick") {
                return {
                    'Authorization': apiKey
                }
            } else if (action === "urlSearch") {
                return {
                    'Content-Type': 'application/json',
                    'Authorization': apiKey
                }
            } else {
                return {
                    'Content-Type': 'image/png;base64',
                    'Authorization': apiKey
                }
            }
        }

        const afterApiCallForHotspot = (res) => {
            const { imageNew = [], action = "", url } = res;
            const { boxes = [], selected } = imageNew;
            setHotspotData({
                boxes: boxes,
                boxId: selected
            });
            // addImageViewerAndBoundingBoxes(action, url);
        }

        const afterApiCall = (res) => {
            const { searchResponse = {} } = res;
            const { products = [], numberOfProducts } = searchResponse;
            setProducts(products);
            if (numberOfProducts > 0) {
                setShowImageZeroResults(false);
                setShowImageResults(true);
            } else {
                setShowImageZeroResults(true);
            }
        }

        const getPayload = () => {
            if (action === "hotSpotClick") {
                return "";
            } else if (action === "urlSearch") {
                return JSON.stringify({
                    imageUrl: url
                })
            } else {
                return base64Payload.current;
            }
        }

        let urlObj = {
            method: action === "hotSpotClick" ? "GET" : "POST",
            headers: getHeaders()
        }

        if (action !== "hotSpotClick") {
            urlObj = { ...urlObj, body: getPayload() }
        }

        fetch(apiUrl, urlObj).then(resp => {
            return resp.json();
        })
            .then((resp) => {
                const { response:searchResponse = {}, searchMetaData = {} } = resp;
                const { image = {} } = searchMetaData;
                imageBoxesRef.current = image;
                searchResponseRef.current = searchResponse;
                const { selected = "" } = image;

                setShowLoader(false);
                setShowSearchPage(true);
                afterApiCall({ image, searchResponse, action, url });
                addImageViewerAndBoundingBoxes(action, url);

                /** Now fire tags api */
                if (action !== "hotSpotClick") {
                    setTagsLoading(true)
                    const def = dataLoader.getRequestDef({
                        requestId: "getImageTags",

                        params: {
                            vertical: (vertical == "footwear") ? "apparel" : vertical,
                            url: action === "urlSearch" ? url : base64Payload.current
                        }
                    })

                    def.done((response = []) => {
                        for (var i = 0; i < response.length; i++) {
                            let boxes = response[i].box;
                            let boxid = 0;
                            let boxid2 = 0;
                            for (var j = 0; j < boxes.length; j++) {
                                boxid = boxid + parseFloat(boxes[j]);
                                boxid2 = boxid2 + (parseInt(boxes[j]) * (j + 1));
                            }
                            response[i].boxid = parseInt(boxid);
                            response[i].boxid2 = boxid2;
                            console.log("created boxId", boxid, boxid2)
                        }
                        /** Filter/Tag box id correct logic for intersection */

                        let  { boxes = [] }  = imageBoxesRef.current;
                        let filteredBoxes = boxes.filter((box) => {
                            let tagObj = response.some((tag) => {
                                console.log("is boxId", box.id, )
                                if(Math.abs(tag.boxid - parseInt(box.id)) <= 10) {
                                    tag.boxid = box.id;
                                    return true;
                                } else if (Math.abs(tag.boxid2 - parseInt(box.id)) <= 10) {
                                    tag.boxid = box.id;
                                    return true;
                                }
                                 else {
                                    return false;
                                }
                            }) || null;
                            if(tagObj) {
                                return true;
                            } else {
                                return false;
                            }
                        });

                        imageClone.current  = cloneDeep(imageBoxesRef.current);
                        imageClone.current.boxes = filteredBoxes;
                        let imageNew = imageClone.current;

                        // afterApiCallForHotspot({ imageNew, searchResponse:searchResponseRef.current, action, url, response });

                        let hotSpotInd = -1;
                        let currentTagData = response.find((item, index) => {
                            if (item.boxid.toString() === selected) {
                                hotSpotInd = index;
                                return true;
                            } else {
                                return false;
                            }
                        }) || null;
                        if (currentTagData) {
                            // afterApiCallForHotspot({ imageNew, searchResponse:searchResponseRef.current, action, url, response });
                            const { tags: currentTags = {} } = currentTagData;
                            const keys = Object.keys(currentTags);
                            let allTags = [];

                            for (var i = 0; i < keys.length; i++) {
                                let tagString = "";
                                let tagValue = currentTags[keys[i]];

                                let tagValueKeys = tagValue.map((val) => {
                                    return Object.keys(val)[0];
                                });
                                tagValueKeys.join(", ");
                                tagString = `${keys[i]} : ${tagValueKeys}`;
                                allTags.push(tagString);
                            }
                            afterApiCallForHotspot({ imageNew, searchResponse:searchResponseRef.current, action, url, response });
                            setTags(allTags);
                            setAllCurrentTags(response);
                            setHotspotIndex(hotSpotInd);
                        } else {
                            setHotspotData({});
                        }

                        setTagsLoading(false);

                    });

                    def.catch((error) => {
                        setTagsLoading(false)
                        setShowLoader(false);
                        console.log(error);
                    });
                } else {
                    let imageNew = imageClone.current;
                    // afterApiCallForHotspot({ imageNew, searchResponse:searchResponseRef.current, action, url, allCurrentTags });
                    let currentTagData = allCurrentTags.find((item) => {
                        return item.boxid.toString() === selected;
                    }) || null;
                    if (currentTagData) {

                        const { tags: currentTags = {} } = currentTagData;
                        const keys = Object.keys(currentTags);
                        let allTags = [];

                        for (var i = 0; i < keys.length; i++) {
                            let tagString = "";
                            let tagValue = currentTags[keys[i]];

                            let tagValueKeys = tagValue.map((val) => {
                                return Object.keys(val)[0];
                            });
                            tagValueKeys.join(", ");
                            tagString = `${keys[i]} : ${tagValueKeys}`;
                            allTags.push(tagString);
                        }
                        afterApiCallForHotspot({ imageNew, searchResponse:searchResponseRef.current, action, url, allCurrentTags });
                        setTags(allTags);

                    } else {
                        setHotspotData({});

                    }
                    setTagsLoading(false)
                }
            }).catch((error) => {
                setTagsLoading(false)
                setShowLoader(false);
            })
    }

    const visualSearchUtilsProps = {
        setImageLoaded,
        setShowImageResults,
        setShowImageZeroResults,
        setTags,
        setAllCurrentTags,
        onSubmitPhoto,
        tags,
        showImageResults,
        showImageZeroResults,
        imageLoaded,
        imageSearchSource,
        canvas,
        base64Payload,
        setStartCamera,
        setShowCanvas,
        setIsImageCaptured,
        isImageCaptured,
        setCanvasSrc,
        startCamera
    }

    const onStartCamera = () => {
        setShowLandingPage(false);
        setStartCamera(true);
    }

    const onSampleImageClick = (action, url) => {
        setShowLandingPage(false);
        //setShowImageSrc(false);
        setSelectedSampleImage(url);

        onSubmitPhoto(action, url);
    }

    const onClearPhoto = () => {
        var context = canvas.current.getContext('2d');
        context.clearRect(0, 0, canvas.current.width, canvas.current.height);
        setIsImageCaptured(false);
        base64Payload.current = "";
        setShowImageSrc(false);
        setImageLoaded(false);
        setShowImageResults(false);
        setShowImageZeroResults(false);
        setTags([]);
        setAllCurrentTags([]);
        setStartCamera(true);
        setShowCanvas(false);
    }

    useEffect(() => {
        let html = document.querySelector("html");
        html.style.height = "100%";
        let body = document.querySelector("body");
        body.style.height = "100%";
        let root = document.querySelector("#root");
        root.style.height = "100%";
        let app = document.querySelector(".App");
        app.style.height = "100%";
    })

    return (
        <div className="vs-demo-container">
            {(showLandingPage || showSearchPage || showCanvas || showLoader) && <Header/>}
            {showLandingPage &&
                <div className="container-wrapper product-highlights">
                    <div className="container grid-xxxl">
                        <div className="columns highlight-info">
                            <div className="column col-md-12 col-xl-6 col-lg-7 col-6">
                                <div className="content-wrap">
                                    <div>
                                        <div className="header">
                                            <div className="mb-2 title">Visual search</div>
                                            <div className="ml-3 try-yourself-box">
                                                <div className="text">Try it yourself</div>
                                            </div>

                                        </div>
                                        <div className="feature-description desc col-xl-12 col-12">
                                            Experience visual AI that powers UNBXD by extracting product attributes, curating similar looks and enriching your catalogue for better search results
                                        </div>

                                        <div className="column col-md-12 col-xl-6 col-lg-5 col-5 vs-img-cont img-class">
                                            <img src="./images/vs.gif" className="vs-img" alt="visual search" />
                                        </div>

                                        <div className="select-vertical mb-1">Select the vertical<span className="mandatory">*</span></div>
                                        <div className="vertical-dd-container">
                                            <div className="vertical-dd" onClick={toggleVerticalDD}>
                                                <span className="vertical-dd-label">{vertical.charAt(0).toUpperCase() + vertical.slice(1)}</span>
                                                <img className="down-arrow-img" src={downArrow} alt="Toggle Dropdown" />
                                            </div>
                                            <ul className={`vertical-dd-list ${verticalClass}`} onClick={onVerticalChange}>
                                                <li className="vertical-dd-list-item" data-vertical="apparel">Apparel</li>
                                                <li className="vertical-dd-list-item" data-vertical="footwear">Footwear</li>
                                                <li className="vertical-dd-list-item" data-vertical="home">Home</li>
                                            </ul>
                                        </div>

                                        <Button className="camera-button" onClick={onStartCamera} >
                                            <span className="camera-icon"></span>
                                            <span className="text">CAPTURE A PHOTO</span>
                                        </Button>
                                        <div className="or-divider">or</div>

                                        <div className="search-container">
                                            <div className="search-input-container">
                                                <input type="text" value={imageURL} onChange={handleImageURLChange} className="search-input" placeholder="Enter Image URL" />
                                                <img src={searchIcon} className="search-img" onClick={handleSubmitImageURL} />
                                            </div>
                                            <button onClick={handleSubmitImageURL} className="search-button">Preview</button>
                                        </div>

                                        <div className="vs-sample-images-text">Try with our sample images</div>

                                        {/* {sampleImages.map((item) => {
                                                        return <img
                                                            key={item}
                                                            className={`product-img ${selectedSampleImage === item ? "product-img-selected" : ""}`}
                                                            src={item}
                                                            onClick={onSampleImageClick.bind(null, "urlSearch", item)}
                                                        />;
                                                    })} */}
                                        <div className="box">
                                            {sampleImages[vertical].map((item) => {
                                                return <img
                                                    key={item}
                                                    className={`product-img ${selectedSampleImage === item ? "product-img-selected" : ""} inline-show box-items`}
                                                    src={item}
                                                    alt="sample img"
                                                    onClick={onSampleImageClick.bind(null, "urlSearch", item)}
                                                />;
                                            })}

                                            {imageURL && (
                                                <img
                                                    key={imageURL}
                                                    className="product-img product-img-selected inline-show box-items"
                                                    src={imageURL}
                                                    alt="sample img"
                                                    onClick={onSubmitImageURL.bind(null, "urlSearch", imageURL)}
                                                />
                                            )}


                                        </div>

                                    </div>
                                </div>
                            </div>
                            <div className="column col-md-12 col-xl-6 col-lg-5 col-5 vs-img-cont vs-img-class-bottom">
                                <img src="./images/vs.gif" className="vs-img" alt="visual search" />
                            </div>
                        </div>
                    </div>
                </div>
            }

            {!showLandingPage && <div className="box">
                {sampleImages[vertical].map((item) => {
                    return <img
                        key={item}
                        className={`product-img ${selectedSampleImage === item ? "product-img-selected" : ""} hide box-items`}
                        src={item}
                        alt="sample img"
                        onClick={onSampleImageClick.bind(null, "urlSearch", item)}
                    />;
                })}

               {imageURL && (
                    <img
                        key={imageURL}
                        className="product-img product-img-selected hide box-items"
                        src={imageURL}
                        alt="sample img"
                        onClick={onSubmitImageURL.bind(null, "urlSearch", imageURL)}
                    />
                )}

            </div>}

            {showLandingPage && <div className="or-divider or-divider-background">See what you can do with Visual search and AI stylist</div>}
            {showLandingPage && <div className="container-wrapper product-highlights">
            <div className="container grid-xxxl">
                    <ExtractProductAttributes />
                    <EnhancedSearchAccuracy />
                    <AiStylist />
                </div>
            </div>
            }

            { startCamera && <VisualSearchCamera {...visualSearchUtilsProps} key="constant" /> }
            <div className={`camera-container for-canvas  ${showCanvas ? "show-flex" : "hide"}`}>
                <canvas id="canvas" className={`vs-demo-2-canvas ${showCanvas ? "show" : "hide"}`}></canvas>
                {showCanvas && isImageCaptured && <div className="image-capture-buttons">
                    <img src={"/images/red_cross.png"} onClick={onClearPhoto} />
                    <img src={"/images/green_tick.png"} onClick={onSubmitPhoto} />
                </div>}
            </div>
            {showLoader && <div className="vs-loader-container">
                <img src="./images/loader.gif" />
                <div className="vs-loader-text">Breaking down your image, this might take a few seconds</div>
            </div>}
            {showSearchPage &&
                <div className="vs-search-page">
                    <div className="vs-search-header-container">
                        <div className="vs-search-header-text">
                            <div className="vs-search-header">We split up your image </div>
                            <div className="vs-search-sub-header">View product attributes & search results</div>
                        </div>
                        <div className="vs-search-header-camera" onClick={() => {
                            setShowLandingPage(true);
                            setShowSearchPage(false);
                        }} >
                            <div className="camera-icon"></div>
                        </div>
                    </div>

                    {showImageSrc && <div className="vs-search-product-attributes">Product attributes</div>}

                    {/* <div className="tags-outer-container"> */}
                    <div className="vs-tags-container">
                        <div className="VS-image-viewer" id="VS-image-viewer">
                            {showImageSrc && <div>
                                <img className="img-with-hotspot" id="vs-img" src={pngImageSrc} onLoad={onImageLoad}></img>
                            </div>
                            }
                            {imageLoaded && <HotSpots hotSpotData={hotSpotData} onHotSpotClick={onHotSpotClick} action={imageSearchSource} />}
                            {(imageLoaded && hotSpotData.boxes && hotSpotData.boxes.length && tags.length) ? hotSpotData.boxes.map((main = {}, index) => {
                                if (index === hotSpotIndex) {
                                    return (
                                        <Xwrapper><Xarrow
                                            start={`img-hotspot-${hotSpotIndex}`} //can be react ref
                                            end={`tags-container-1`} //or an id
                                            zIndex={1000}
                                            endAnchor={{ position: "left", offset: { x: 0 } }}
                                            dashness={{ strokeLen: 10, nonStrokeLen: 10, animation: -2 }}
                                            animateDrawing={true}
                                        /></Xwrapper>
                                    )
                                }

                            }) : ""}
                        </div>

                        {((tags.length && tags.length)> 0 || tagsLoading) ? <div id="tags-container-1">
                            {tagsLoading ? <img className="vs-loading-icon" alt="tags img" src="./images/blueLoader.svg" /> : <Tags tags={tags} />}
                        </div>:""}
                    </div>
                    {showImageZeroResults && <div id="noResultWrapper" className="vs-products">
                        No Results to show
                    </div>}
                    <div className="UNX-product-wrapper" id="searchResultsWrapper">
                        {showImageResults &&
                            <Fragment>
                                <div className="vs-products">Products</div>
                                <div className="UNX-search-results-block UNX-result-wrapper UNX-grid-block">

                                    <Products products={products} />
                                </div>
                            </Fragment>
                        }
                    </div>
                    <div className="try-image-container">
                        <Button onClick={() => {
                            setShowLandingPage(true);
                            setShowSearchPage(false);
                        }} className="camera-button">
                            <span className="camera-icon"></span>
                            <span className="text">TRY ANOTHER IMAGE</span>
                        </Button>
                    </div>
                </div>}
           {(showLandingPage || showSearchPage) &&  <Footer />}
        </div>
    )
}

export const Tags = ({ tags }) => {

    return (
        <div id="tags-container">
            {tags.map((item) => {
                return <span key={item} className="listing-tag">{item}</span>
            })}
        </div>
    )
}

export const Products = ({ products }) => {
    const DEFAULT_IMAGE = "https://libraries.unbxdapi.com/sdk-assets/defaultImage.svg";

    return products.map((product, idx) => {
        let {
            uniqueId,
            imageUrl,
            title,
            name,
            price,
            sellingPrice
        } = product;
        const {
            productItemClass
        } = products;

        let productViewType = "GRID"

        let imgUrl = Array.isArray(imageUrl) ? imageUrl[0] : imageUrl;
        imgUrl = imgUrl ? (imgUrl.trim() || DEFAULT_IMAGE) : DEFAULT_IMAGE;
        let cardType = ``;
        if (productViewType === "GRID") {
            cardType = "UNX-grid-card"
        } else {
            cardType = "UNX-list-card";
        }

        return (<div id={`pid_${uniqueId}`} data-id={uniqueId} key={uniqueId} data-prank={idx} data-item="product" className={`UNX-product-col ${cardType} ${productItemClass}`}>
            <div className="UNX-images-block">

                <div className="UNX-img-wrapper  UNX-parent-image"><img className="UNX-img-block" src={imgUrl} /></div>
            </div>
            <div className="UNX-product-content">
                <h3 className="UNX-product-title" title={title}>{title || name || uniqueId || ""}</h3>
            </div>
        </div>)
    });
}

export const PriceRow = ({ price, sellingPrice, prefix = "$" }) => {
    let displayPrice = sellingPrice || price;
    return (
        <div>

            {
                displayPrice ? <span className="UNX-sale-price">{prefix}{displayPrice.toFixed(2)}</span> : ""
            }

            {
                (price && sellingPrice && (price !== sellingPrice)) ? <span className="UNX-strike-price">{prefix}${price.toFixed(2)}</span> : ""
            }

        </div>
    )
};

export const HotSpots = ({ hotSpotData, onHotSpotClick, action }) => {
    if (hotSpotData && hotSpotData.boxes && hotSpotData.boxes.length === 0) {
        return "";
    }
    return hotSpotData.boxes && hotSpotData.boxes.length && hotSpotData.boxes.map((item, index) => {
        const { id: localBoxId, vertices = [], url = "" } = item;

        const x = vertices[0].x,
            y = vertices[0].y,
            width = vertices[1].x - vertices[0].x,
            height = vertices[1].y - vertices[0].y;
        let sourceEl = "";
        let scaleX = 1;
        let scaleY = 1;
        let destEl = document.querySelector(".img-with-hotspot");

        if (action === "urlSearch") {
            sourceEl = document.querySelector(".product-img-selected");
            if (sourceEl) {
                scaleX = sourceEl.naturalWidth / destEl.offsetWidth;
                scaleY = sourceEl.naturalHeight / destEl.offsetHeight;
            }
        } else {
            sourceEl = document.querySelector(".vs-demo-2-canvas");
            scaleX = sourceEl.width / destEl.offsetWidth;
            scaleY = sourceEl.height / destEl.offsetHeight;
        }


        const left = (x + width / 2) / scaleX - 10;
        const top = (y + height / 2) / scaleY - 10;
        const styleJson = {
            top: `${top}px`,
            left: `${left}px`
        }

        return (
            <div className="hotspot" id={`img-hotspot-${index}`} url={url} style={styleJson}
                key={localBoxId} onClick={onHotSpotClick.bind(null, url, index)}></div>
        )

    })
}

export default VisualSearchLanding;
